import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../helpers/reducerRegistry'
import { handleInternationalData, handleOtherCountry } from '../helpers'
import {
  getCountries,
  getHeaderActiveStatus,
  getHeaderSearchHistories,
  getInternationalCompany,
  getInternationalSearchHistory,
  postHeaderDomesticSearch,
} from './thunk'

const initialState = {
  searchData: [],
  historyData: [],
  statusData: [],
  locationData: [],
  loading: false,
  country: {},
  otherCountry: [],
}

const slice = createSlice({
  name: 'headerSearch',
  initialState,
  reducers: {
    resetSearchData: (state) => {
      state.searchData = []
      state.loading = true
    },
    changeLoading: (state, action) => {
      state.loading = action.payload
    },
    resetHistoryData: (state) => {
      state.historyData = []
    },
    removeHistoryData: (state, action) => {
      state.historyData = [...state.historyData].filter(
        (item) => item.organizationId !== action.payload,
      )
    },
    removeHistoryInternational: (state, action) => {
      const companyRemovedId = action.payload
      state.historyData = state.historyData.filter(
        (item) => item.companyId !== companyRemovedId,
      )
    },
  },
  extraReducers: (builder) => {
    builder.addCase(postHeaderDomesticSearch.pending, (state) => {
      state.loading = true
      state.searchData = []
    })
    builder.addCase(postHeaderDomesticSearch.fulfilled, (state, action) => {
      state.searchData = action.payload
      state.loading = false
    })
    builder.addCase(postHeaderDomesticSearch.rejected, (state, action) => {
      state.loading = action.payload.loading
    })
    builder.addCase(getHeaderSearchHistories.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getHeaderSearchHistories.fulfilled, (state, action) => {
      state.historyData = action.payload.map((item) => ({
        ...item,
        viewAllowed:
          typeof item.viewAllowed === 'undefined' ? true : item.viewAllowed,
      }))
      state.loading = false
    })
    builder.addCase(getHeaderSearchHistories.rejected, (state, action) => {
      state.loading = action.payload.loading
    })
    builder.addCase(getHeaderActiveStatus.fulfilled, (state, action) => {
      state.statusData = action.payload
    })
    builder.addCase(getInternationalSearchHistory.pending, (state) => {
      state.loading = true
    })
    builder.addCase(
      getInternationalSearchHistory.fulfilled,
      (state, action) => {
        const data = Array.isArray(action.payload) ? action.payload : []
        state.historyData = handleInternationalData(data)
        state.loading = false
      },
    )
    builder.addCase(getInternationalSearchHistory.rejected, (state, action) => {
      state.loading = action.payload.loading
    })
    builder.addCase(getInternationalCompany.pending, (state) => {
      state.loading = true
      state.searchData = []
    })
    builder.addCase(getInternationalCompany.fulfilled, (state, action) => {
      const data = Array.isArray(action.payload) ? action.payload : []
      state.searchData = handleInternationalData(data)
      state.loading = false
    })
    builder.addCase(getInternationalCompany.rejected, (state, action) => {
      state.loading = action.payload.loading
      state.searchData = []
    })
    builder.addCase(getCountries.fulfilled, (state, action) => {
      const otherCountry = action.payload || []
      state.otherCountry = handleOtherCountry(otherCountry)
    })
  },
})

export const selectSearchData = (state) => state[slice.name].searchData
export const selectHistoryData = (state) => state[slice.name].historyData
export const selectStatusData = (state) => state[slice.name].statusData
export const selectLoading = (state) => state[slice.name].loading
export const selectOtherCountry = (state) => state[slice.name].otherCountry

export const {
  changeLoading,
  resetHistoryData,
  removeHistoryData,
  removeHistoryInternational,
  resetSearchData,
} = slice.actions

register(slice.name, slice.reducer)
